var viewModel = {
    Loading: ko.observable(false),

    // Static Content
    HasChangesForCategoryViewStaticPageRegions: ko.observable(hasChangesForCategoryViewStaticPageRegions),

    // Results
    Categories: ko.observableArray([]),

    // Filters
    SearchText: ko.observable("")
};

window.SwitchToListView = function SwitchToListView() {
    window.location.href = window.location.pathname;
}

window.SwitchToMapView = function SwitchToMapView() {
    window.location.href = window.location.pathname + '?MapView=true';
}

var reloadListing = function () {
    viewModel.Loading(true);

    var data = {
        "directoryID": directoryID,
        "searchText": viewModel.SearchText()
    };

    $.ajax({
        type: "POST",
        url: categoryListHtmlUrl,
        data: data,
        dataType: "json",
        success: function (data) {
            $("#categories-container").html(data.Html);
            viewModel.Categories(data.Categories);
            if (window.noviCmsNamespace.isPageEditToggled) {
                var contentRegionsLoadedEvent = new CustomEvent(window.noviCmsNamespace.contentRegionsLoadedEvent, { detail: {} , bubbles: true, cancelable: true });
                document.dispatchEvent(contentRegionsLoadedEvent);
            }
            viewModel.Loading(false);
        },
        error: function (jqXHR, textStatus) {
            if (textStatus === 'abort' || jqXHR.status === 0)
                return;

            if (jqXHR && jqXHR.responseJSON) {
                var apiErrorResponse = jqXHR.responseJSON;
                ShowCustomAlert(apiErrorResponse.Message + (apiErrorResponse.ErrorDetails ? "<br/><br/> Error Details: <br/>" + apiErrorResponse.ErrorDetails : ""));
            }
            else {
                ShowCustomAlert('There was an error loading the directory category view: ' + jqXHR.responseText);
            }
            viewModel.IsLoading(false);
        }
    });
}

function ResetStaticContentRegions() {
    viewModel.Loading(true);

    $.ajax({
        type: "POST",
        url: resetContentUrl,
        data: {
            "directoryID": directoryID,
            "filter": "CategoryView",
            "categoryView" : true
        },
        dataType: "json",
        success: function (data) {
            if (data.Status === "Invalid") {
                ShowCustomAlert('There was an error resetting the content: ' + data.Errors);
            }
            else {
                if (data.BaseRegions) {
                    data.BaseRegions.forEach(function (region) {
                        setStaticContent(region.RegionName, region.Html);
                    });
                }

                viewModel.HasChangesForCategoryViewStaticPageRegions(false);
                viewModel.Loading(false);
                ShowSavedPopup('The content regions were reset successfully.', '');
            }
        },
        error: function (jqXHR, textStatus) {
            if (textStatus === 'abort' || jqXHR.status === 0)
                return;

            if (jqXHR && jqXHR.responseJSON) {
                var apiErrorResponse = jqXHR.responseJSON;
                ShowCustomAlert(apiErrorResponse.Message + (apiErrorResponse.ErrorDetails ? "<br/><br/> Error Details: <br/>" + apiErrorResponse.ErrorDetails : ""));
            }
            else {
                ShowCustomAlert('There was an error resetting the content: ' + jqXHR.responseText);
            }
            viewModel.Loading(false);
        }
    });
}

function setStaticContent(region, content) {

    // Fetch the static region - its structure is different depending on whether the region is editable
    tinyRegion = $("#editable_" + region); // For admins
    if (!tinyRegion.length) {
        tinyRegion = $("[data-region='" + region + "']"); // For standard users
    }

    if (tinyRegion && tinyRegion.length) {
        // New method for setting editor content
        if (typeof setEditorContent !== "undefined") {
            setEditorContent(region, content);
        }
        // Legacy method for setting editor content
        else if (typeof SetEditorContent !== "undefined") {
            SetEditorContent(region, content);
        }
        else {
            tinyRegion.html(content);
        }

        if (content) {
            tinyRegion.removeClass("empty");
        }
        else {
            tinyRegion.addClass("empty");
        }
    }
}

function resetSearch() {
    viewModel.SearchText("");
    reloadListing();
}

$(function () {
    var directoryRoot = document.querySelector('.directory-list-container');
    if (directoryRoot) {
        applyBindingsSafely(window, directoryRoot);
    }

    $("#search-box").keydown(function (e) {
        var key = e.charCode || e.keyCode || 0;
        if (key == 13) {
            $("#search-go").click();
        }
    });

    reloadListing();
});